import { identityBaseUrl as baseUrl, authHeaders, handle } from './identityHttp';

// Super admin management — talks to Identity-Api (/api/v1/super-admins) directly.
// The backend enforces every rule (SuperUser gate, protected accounts, manager-only
// promote/demote); the UI mirrors them only for affordance.

export async function listSuperAdmins() {
  const res = await fetch(`${baseUrl()}/api/v1/users/search`, {
    method: 'POST',
    headers: await authHeaders(),
    body: JSON.stringify({
      roleCodes: ['SuperAdmin', 'SuperUser'],
      hasAnyRole: true,
      pageSize: 100,
      includeRoles: true,
    }),
  });
  const body = await handle(res);
  return body?.users || body?.items || body?.data || (Array.isArray(body) ? body : []);
}

export async function addSuperAdmin(payload) {
  return handle(
    await fetch(`${baseUrl()}/api/v1/super-admins`, {
      method: 'POST',
      headers: await authHeaders(),
      body: JSON.stringify(payload),
    }),
  );
}

export async function removeSuperAdmin(userId, reason) {
  const qs = reason ? `?reason=${encodeURIComponent(reason)}` : '';
  return handle(
    await fetch(`${baseUrl()}/api/v1/super-admins/${userId}${qs}`, {
      method: 'DELETE',
      headers: await authHeaders(),
    }),
  );
}

const action = async (userId, verb) =>
  handle(
    await fetch(`${baseUrl()}/api/v1/super-admins/${userId}/${verb}`, {
      method: 'POST',
      headers: await authHeaders(),
    }),
  );

export const promoteSuperAdmin = (userId) => action(userId, 'promote');
export const demoteSuperAdmin = (userId) => action(userId, 'demote');
export const resetSuperAdminPassword = (userId) => action(userId, 'reset-password');
export const resetSuperAdminMfa = (userId) => action(userId, 'reset-mfa');
